import { render, staticRenderFns } from "./Agents.vue?vue&type=template&id=ec9addc8&scoped=true&"
import script from "./Agents.vue?vue&type=script&lang=js&"
export * from "./Agents.vue?vue&type=script&lang=js&"
import style0 from "./Agents.vue?vue&type=style&index=0&id=ec9addc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9addc8",
  null
  
)

export default component.exports